import React, {Fragment, useEffect, useRef, useState} from 'react';
import {Link} from "react-router-dom";
import {Can} from "../../ability-context";
import _ from "lodash";
import createLink from "../../libs/createLink";
//import {deleteMedia, updateMedia} from "../../creators/media";
//import {reportMedia} from "../../creators/report";
import DateSince from './Date';
import Dropdown from './Dropdown';
import Player from './Player';
import Avatar from './Avatar';
import Report from './Report';
import {PageLoader, SpinLoader} from './Loader';
import Icon from './Icon';
import MoveMedia from './MoveMedia';
import Alert from './Alert';
import ViewMore from './ViewMore';
import Modal from "./Modal";
import LikeList from "./Like/LikeList";
import LikeBtn from "./Like/LikeBtn";

import {
    canonical,
    cropText, genererViews,
    isBot,
    isNoFollowAlbum, isNoFollowMedia, isNoFollowProfil, legendToTitle,
    separateurNumber
} from "../../libs/helper";
import Helmet from "react-helmet";
import Breadcrumbs from "./Breadcrumbs";
import {Button} from "./Button";
import SwipeableHook from "../hoc/Swipeable";

import Advertising from "./Advertising/Advertising";
import ErrorNotFound from "../pages/ErrorNotFound";
import ViewsComment from "./ViewComment";
//import MediaEdit from "../components2/mediaEdit/MediaEdit";
//import EncourageSignup from "../components2/encourageSignup/EncourageSignup";
import Warning from "./warnings/Warning";
import Comments from "./comments/Comments";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";

import {
    deleteMedia,
    fetchMedia,
    MEDIA_KEY,
    MEDIA_SET_COUNT_KEY,
    MEDIAS_KEY, reportMedia,
    setMediaCountViews, updateMedia
} from "../../api/public-voissa/medias";
import {
    USER_CURRENT_KEY,
    USER_PROFILE_MEDIAS_KEY
} from "../../api/public-voissa/users";
import {toastError, toastSuccess} from "../../libs/toast";
import {MEDIA} from "../../const/toasts";
import loadable from '@loadable/component';
import {ALBUM_MEDIAS_KEY} from "../../api/public-voissa/albums";
import ModalNewsLetterGuest from "./newsletterGuest/NewsletterGuest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/pro-regular-svg-icons';
import { faBookmark as faBookmarkSolid } from '@fortawesome/pro-solid-svg-icons';
import useMediaBookMark from '../../hooks/useMediaBookmark';
import Reader from "../../libs/lexical/Reader";
const MediaEdit = loadable(() => import("../components2/mediaEdit/MediaEdit"));


const MediaViewer = ({
        isPage = false,
        mediaId = null,
        mediaSlug = "",
        handleClose = () =>{},
        owner = {},
        urlAlbum = ""
    }) =>{
    let isToggleMediaEdit = false;
    if(window.location.hash.match(/[#&]edit/) && isPage){
        let url = window.location.href.replace("#edit", "");
        window.history.pushState("", "",url);
        isToggleMediaEdit = true;
    }
    const locationRef = useRef(window.location.href);
    const queryClient = useQueryClient();
    //const navigate = useNavigate();

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isSuccessCurrentUser = _.get(dataCurrentUser, '_id');


    const [toggleEncourageSignup, setToggleEncourageSignup] = useState(false);
    const [desactivatePictureAlert, setDesactivatePictureAlert] = useState(false);
    const [toggleMediaEdit, setToggleMediaEdit] = useState(isToggleMediaEdit);
    const [toggleMovePicture, setToggleMovePicture] = useState(false);
    const [isToggleAlertDelete, setIsToggleAlertDelete] = useState(false);
    const [isEnableFullScreen, setIsEnableFullScreen] = useState(false);
    const [isEnableArrow, setIsEnableArrow] = useState(true);
    const [toggleLikeList, setToggleLikeList] = useState(false);
    const [currentMedia, setCurrentMedia] = useState({_id : mediaId, slug : mediaSlug});
    const [toggleWarning, setToggleWarning] = useState(false);
    const [isMediaLoaded,setIsMediaLoaded] = useState(false);
    const [isMediaError,setIsMediaError] = useState(false);

    let query = currentMedia?.slug?.length ? {slug : currentMedia.slug} : {};

    const {isSuccess : isSuccessMedia, isFetched : isFetchedMedia, error : errorMedia, data : dataMedia} = useQuery(
        [MEDIA_KEY, currentMedia._id, query],
        ()=> fetchMedia(currentMedia._id, query),
        {
            staleTime : (1000 * 60 * 5),
            enabled : !!mediaId,
            onSuccess : async (data) =>{
                checkEncourage();
            }
        }
    );

    const {isBookmarked, handleBookmark} = useMediaBookMark(dataMedia?.isBookmarked, dataMedia?._id);
    const {
        mutate : mutateUpdateMedia,
    } = useMutation((data) => updateMedia(currentMedia._id, data),{
        onSuccess: async () =>{
            await queryClient.invalidateQueries([USER_PROFILE_MEDIAS_KEY]);
            await queryClient.invalidateQueries([MEDIAS_KEY]);
            await queryClient.invalidateQueries([MEDIA_KEY, currentMedia._id]);
        },
        onError: () =>{
            toastError(MEDIA.ERROR.UPDATE);
        }
    });

    const {
        mutate : mutateDeleteMedia,
    } = useMutation((mediaId) => deleteMedia(mediaId),{
        onSuccess: async () =>{
            const queryCache = queryClient.getQueryCache()
            const queryKeys = queryCache.getAll().map(cache => cache.queryKey).filter(cache => cache[0] === USER_PROFILE_MEDIAS_KEY || cache[0] === MEDIAS_KEY || cache[0] === ALBUM_MEDIAS_KEY);
            queryKeys.map(async queryKey =>{
                await queryClient.invalidateQueries(queryKey);
            });
            setTimeout(async () =>{
                await queryClient.invalidateQueries([MEDIA_KEY, currentMedia._id]);
            }, 200);
            handleClose();
        },
        onError: () =>{
            toastError(MEDIA.ERROR.UPDATE);
        }
    });

    const {
        mutate : mutateReportMedia,
    } = useMutation(data => reportMedia(currentMedia._id, data),{
        onSuccess: () =>{
            toastSuccess(MEDIA.SUCCESS.REPORT);
        },
        onError: () =>{
            toastError(MEDIA.ERROR.REPORT);
        }
    });

    useQuery(
        [MEDIA_SET_COUNT_KEY, currentMedia._id],
        ()=> setMediaCountViews(currentMedia._id),
        {
            staleTime : (1000 * 60 * 60),
            cacheTime : (1000 * 60 * 60),
            retry : false,
            enabled : !!currentMedia._id && !!isSuccessMedia
        }
    );


    function checkEncourage(){
        let signup = parseInt(localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_ms_signup`)) || 0;
        if(!isSuccessCurrentUser && !isBot && signup === 0){
            let total = parseInt(sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_ms_total`)) || 0;
            let dateNow = parseInt((new Date().getTime() / 1000).toFixed(0));

            let dateVisite = parseInt(sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_ms_date`)) || dateNow;
            let dateExpireVisite = parseInt((dateVisite + ( 60 * 10 )).toFixed(0));

            total++;

            if(total > 10 && dateExpireVisite >= dateNow){
                total = 1;
                setToggleEncourageSignup(true)
            }
            else if(dateExpireVisite < dateNow){
                total = 1;
                dateVisite = dateNow;
            }
            sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_ms_date`, dateVisite);
            sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_ms_total`, total);

        }
    }

    function handleMediaLoaded() {
        //this.setState({mediaLoaded: true, error: false});
        setIsMediaLoaded(true);
        setIsMediaError(false);
    }

    function handleErrorLoaded() {
        //this.setState({mediaLoaded: false, error: true});
        setIsMediaLoaded(false);
        setIsMediaError(true);
    }

    function mediaNext(data){
        if(data._id){
            let countThumb = data.collections && data.collections.length - 1;
            let currentIndex = countThumb && data.collections.findIndex(item => item._id === data._id) + 1;
            if (currentIndex > countThumb) {
                currentIndex = 0;
            }
            return {_id : data.collections[currentIndex]._id, slug : data.collections[currentIndex].slug};
        }
        return currentMedia;
    }

    function mediaPrev(data){
        if(data._id){
            let countThumb = data.collections && data.collections.length - 1;
            let currentIndex = countThumb && data.collections.findIndex(item => item._id === data._id) - 1;
            if (currentIndex > countThumb) {
                currentIndex = 0;
            }
            return {_id : data.collections[currentIndex]._id, slug : data.collections[currentIndex].slug};
        }
        return currentMedia;
    }

    function nextThumb() {
        if(isFetchedMedia && !toggleEncourageSignup){
            setIsMediaLoaded(false);
            setIsMediaError(false);
            //this.setState({mediaLoaded: false, error: false});

            let nextMedia = mediaNext(dataMedia);
            setCurrentMedia(nextMedia);
            //this.fetchMedia(this.props.media.collections[currentIndex]._id || this.props.mediaId);
            window.history.pushState("", "", createLink(dataMedia.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {...owner, media : nextMedia}));
        }
    }

    function prevThumb() {
        if(isFetchedMedia && !toggleEncourageSignup){
            setIsMediaLoaded(false);
            setIsMediaError(false);

            let prevMedia = mediaPrev(dataMedia);
            setCurrentMedia(prevMedia);
            window.history.pushState("", "", createLink(dataMedia.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {...owner, media : prevMedia}));
        }
    }
    

    function fullscreen() {
        setIsEnableFullScreen(!isEnableFullScreen);
    }

    async function handleKeyPress({key}) {
        let isArrow = isFetchedMedia && dataMedia.collections && dataMedia.collections.length >= 2;
        switch (key) {
            case 'ArrowRight':
                if (isArrow && isFetchedMedia) nextThumb();
                break;
            case 'ArrowLeft':
                if (isArrow && isFetchedMedia) prevThumb();
                break;
            case 'Escape':
                if (isEnableFullScreen) {
                    fullscreen();
                } else {
                    handleClose();
                }
                break;
            default:
        }
    }


    function handleDeletePicture() {
        mutateDeleteMedia(currentMedia._id);
        //this.props.deleteMedia(this.props.media._id);
        /*if (dataMedia.collections.length && dataMedia.collections.length >= 2) {
            nextThumb();
        } else {
            handleClose();

        }*/

        setIsToggleAlertDelete(false);
    }

    function handleMovePicture() {
        setToggleMovePicture(false);
        //this.setState({movePicture: false});
        if (dataMedia.collections.length) {
            nextThumb();
        } else {
            handleClose();
        }
    }

    function handlePicture() {
        //setTimeout(() => this.fetchMedia(this.props.mediaId ? this.props.mediaId : 0), 500);
        setToggleMediaEdit(false)
    }

    function handleStatusMedia() {
        mutateUpdateMedia({status : !dataMedia.status});
        setDesactivatePictureAlert(false);
    }


    function gotoUrl(uri){
        uri = uri ? createLink('facette', {slug : uri}) : false;
        if(uri){
            //navigate(uri);
            window.location = uri;
        }
    }

    //todo: verifier avec max
    useEffect(() => {
        const handleData = () => {
            if(isEnableArrow) {
                document.addEventListener("keydown", handleKeyPress);
            }
            else{
                document.removeEventListener("keydown", handleKeyPress);
            }
        }
        handleData();
        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
        // eslint-disable-next-line
    }, [dataMedia, isEnableArrow]);

    useEffect(() => {
        const currentLocation = locationRef.current;
        if (isSuccessMedia && !isPage) {
            window.history.pushState(
                "", 
                "", 
                createLink(
                    dataMedia.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", 
                    {...dataMedia.owner, media : dataMedia}
                )
            );
        }
        return ()=>{
            if(currentLocation && !isPage) window.history.pushState('','', currentLocation);
        }
    }, [isSuccessMedia, dataMedia, isPage]);


    /*useEffect(() =>{
        return () =>{
            if(urlAlbum){
                window.history.pushState("", "", urlAlbum);
            }
        }
    }, [urlAlbum])*/

    if(isPage && _.get(errorMedia,"statusCode") === 404){
        return <ErrorNotFound />
    }
    let linkAlbum = "";
    let relLinkAlbum = {};
    let relLinkProfil = {};
    let relLinkMedia = {};
    let urlCanonical = "";

    let ownerMedia = {
        _id: null,
        username: 'guest',
        slug: '',
        profile: {
            avatar: '',
            gender: ''
        }
    };

    if(isSuccessMedia){
        let newOwnerMedia = _.get(dataMedia, 'owner') || {};
        ownerMedia  = {
            ...ownerMedia,
            ...newOwnerMedia
        }
    }

    if(isSuccessMedia && dataMedia.album){
        linkAlbum = createLink("userCollection", {...ownerMedia, album : {_id : dataMedia.album._id, slug : dataMedia.album.slug}});
        relLinkAlbum = isNoFollowAlbum(dataMedia.album) ? { rel: "nofollow" } : {};
        relLinkProfil = isNoFollowProfil(ownerMedia) ? { rel: "nofollow" } : {};
        relLinkMedia = isNoFollowMedia(dataMedia) ? { rel: "nofollow" } : {};
        urlCanonical = canonical(createLink(dataMedia.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {...ownerMedia, media : dataMedia}), "", "mediaviewver");
    }
    let heightLimit = 18 * 5;
    let isArrow = dataMedia && dataMedia.collections && dataMedia.collections.length >= 2;

    let breadCrumbsData = [];

    if(isSuccessMedia) {
        let titleMedia = legendToTitle(_.get(dataMedia, "legend") || "");

        if (dataMedia.kind === "video") {
            breadCrumbsData.push({
                name: "Vidéos Sexe",
                link: canonical(createLink("videos"), "", "videos"),
                to: createLink("videos"),
                relLink : {}
            });
        } else {
            breadCrumbsData.push({
                name: "Photos Sexe",
                link: canonical(createLink("photos"), "", "photos"),
                to: createLink("photos"),
                relLink : {}
            });
        }

        breadCrumbsData.push({
            name: _.get(dataMedia, "owner.username"),
            link: canonical(createLink("userProfile", ownerMedia), "", "profile"),
            to: createLink("userProfile", ownerMedia),
            relLink : relLinkProfil
        });
        breadCrumbsData.push({
            name: _.get(dataMedia, "album.title"),
            link: canonical(linkAlbum, "", "album"),
            to: linkAlbum,
            relLink : relLinkAlbum
        });
        breadCrumbsData.push({
            name: titleMedia !== "" ? titleMedia : "N/A",
            link: urlCanonical,
            to: createLink(dataMedia.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {
                ...ownerMedia,
                media: dataMedia
            }),
            relLink : relLinkMedia
        });
    }


    return !isSuccessMedia ? <PageLoader/> : (
        <Fragment>
            {/*<EncourageSignup toggle={toggleEncourageSignup} handleClose={()=>setToggleEncourageSignup(false)} />*/}
            <ModalNewsLetterGuest toggle={toggleEncourageSignup} handleClose={()=>setToggleEncourageSignup(false)} />
            {isPage ? <Advertising sizeMobile={"300x100"} className={"center"} /> : null}
            <div className={`media-viewer ${isEnableFullScreen ? 'active' : ''} ${isPage ? 'mediaviewer-page' : ''}`}>
                {isFetchedMedia && dataMedia.legend ? (<Helmet>
                    <title>{dataMedia.kind === 'video' ? 'Vidéo' : "Photo"} {legendToTitle(dataMedia?.legend || "")} ({dataMedia.album && dataMedia.album.title ? dataMedia.album.title : ''}) - Voissa</title>
                    <meta name="description" content={cropText(dataMedia.legend, 130)} />
                    <link rel="canonical" href={urlCanonical} />
                    {/*metaLeywords && (<meta name="keywords" content={metaLeywords} />)*/}
                    {isNoFollowMedia(dataMedia) ? <meta name="robots" content="noindex" /> : null}

                </Helmet>) : null}
                <div className="media-layout">
                    <SwipeableHook
                        className={"media-main-wrapper"}
                        paramsSwipe={
                            {
                                onSwipedLeft: () => dataMedia.kind === "video" ? null : prevThumb(),
                                onSwipedRight: () => dataMedia.kind === "video" ? null : nextThumb(),
                                preventDefaultTouchmoveEvent: true,
                                trackMouse: false
                            }
                        }
                    >

                        {isPage && (
                            <div className={"nav-breadcrumbs"} id={"test"}>
                                <Breadcrumbs data={breadCrumbsData} />
                            </div>
                        )}
                        {isFetchedMedia && !dataMedia.status && <div className="desactivated-layer">
                            <span className="badge red desactivated-badge">Media désactivé</span>
                        </div>}
                        {!dataMedia.display ? <div className="desactivated-layer">
                                    <span
                                        className="badge red display-warning"
                                        onClick={()=>setToggleWarning(true)}
                                    >Publications invisibles - Consulter le message de la modération sur votre profil
                                    </span>
                        </div> : null }
                        {((!isFetchedMedia && dataMedia.kind !== 'video') ? <SpinLoader/> : '')}
                        {(isFetchedMedia && dataMedia.kind === 'video') ? (
                            <div className={`wrapper-img media-main-wrapper ${(!isBot && !isMediaLoaded) && 'loading'}`}>
                                <Player media={dataMedia} />
                                <div className={`infos-media`}>
                                    {dataMedia.collections && dataMedia.collections[0] ?
                                        <div>
                                            <div className="previous" onClick={_ => {
                                                prevThumb()
                                            }}><Icon type="chevron-left"/></div>
                                            <div className="next" onClick={_ => {
                                                nextThumb()
                                            }}><Icon type="chevron-right"/></div>

                                        </div>
                                        : ''
                                    }

                                </div>
                            </div>
                        ) : (
                            <div className={`wrapper-img ${(!isBot && !isMediaLoaded) ? 'loading' : ""}`}>
                                {!isBot && isMediaError && !isFetchedMedia && (<div className="no-image-found">Image introuvable</div>)}
                                {isFetchedMedia && (
                                    <Can action="clickRight" subject="Media" passThrough>
                                        {can => {
                                            return (
                                                <img
                                                    src={`${dataMedia.previewUrl}?wm=1`}
                                                    onLoad={()=>handleMediaLoaded()}
                                                    alt={legendToTitle(dataMedia?.legend || "")}
                                                    style={(!isBot && isMediaError) ? {'display': 'none'} : {}}
                                                    onError={()=>handleErrorLoaded()}
                                                    onContextMenu={!can ? (e)=> e.preventDefault() : null}
                                                    onDragStart={!can ? (e)=> e.preventDefault() : null}
                                                />)
                                        }}
                                    </Can>

                                )}
                                <div className={`infos-media ${(!isBot && !isMediaLoaded) && 'loading'}`}>
                                    <div className="fullscreen" onClick={fullscreen}>
                                        {!isEnableFullScreen ? (
                                            <Icon type="arrows-alt"/>
                                        ) : (
                                            <Icon type="compress"/>
                                        )}
                                    </div>
                                    {dataMedia.collections && dataMedia.collections[0] ?
                                        <Fragment>
                                            {isArrow && (<div className="previous" onClick={_ => {
                                                prevThumb()
                                            }}><Icon type="chevron-left"/></div>)}
                                            {isArrow && (<div className="next" onClick={_ => {
                                                nextThumb()
                                            }}><Icon type="chevron-right"/></div>)}
                                        </Fragment>
                                        : ''
                                    }

                                </div>
                            </div>
                        )}

                    </SwipeableHook>
                    <div className="media-sidebar">
                        {!isFetchedMedia ? <PageLoader/> : (
                            <Fragment>
                                <div className="media-informations">
                                    <div className="media-user">
                                        <div>
                                            <Link
                                                to={createLink("userProfile", ownerMedia)}
                                                {...relLinkProfil}
                                                className="user link">
                                                <Avatar avatar={_.get(ownerMedia,"profile.avatar") || ""}
                                                        gender={_.get(ownerMedia,"profile.gender") || 0}
                                                        width={150}
                                                        height={150}
                                                        alt=""/>
                                            </Link>
                                        </div>
                                        <div className="media-user-info">
                                            <div className="topline">
                                                {ownerMedia._id ? (
                                                    <div>
                                                        <Link
                                                            to={createLink("userProfile", ownerMedia)}
                                                            {...relLinkProfil}
                                                            className="user link">{ownerMedia.username}</Link>
                                                        <DateSince
                                                            date={dataMedia.createdAt}
                                                            prefix={false}
                                                            currentFormat={true}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <div className="user link">{dataMedia.authorName}</div>
                                                        <DateSince
                                                            date={dataMedia.createdAt}
                                                            prefix={false}
                                                            currentFormat={true}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="album-infos">
                                                Dans la collection&nbsp;
                                                {urlAlbum === linkAlbum ? (
                                                    <Link to={"#"} className="album link"
                                                          onClick={() => handleClose()}
                                                          {...relLinkAlbum}
                                                    >
                                                        {dataMedia.album && dataMedia.album.title ? dataMedia.album.title : ''}
                                                    </Link>
                                                ) : (
                                                    <Link
                                                        to={linkAlbum}
                                                        {...relLinkAlbum}
                                                        className="album link">{dataMedia.album && dataMedia.album.title ? dataMedia.album.title : ''}</Link>
                                                )}

                                            </div>
                                        </div>
                                        {isSuccessCurrentUser ? (
                                            <Dropdown align="right" activableComponent={(
                                                <Icon type={"vertical-dots"}/>
                                            )}>
                                                <ul className="dropdown-menu">
                                                    <Can action={"update"} subject={dataMedia} modelName="Media">
                                                        <li className="menu-item"
                                                            onClick={() => setToggleMediaEdit(true)}><Icon
                                                            type="pencil"/> Editer
                                                        </li>
                                                    </Can>
                                                    <Can action={"move"} subject={dataMedia} modelName="Media">
                                                        <li className="menu-item"
                                                            onClick={() => setToggleMovePicture(true)}><Icon
                                                            type="long-arrow-right"/> Déplacer dans un autre album
                                                        </li>
                                                    </Can>
                                                    <Can action={"status"} subject={dataMedia} modelName="Media">
                                                        <li className="menu-item"
                                                            onClick={() => setDesactivatePictureAlert(true)}>
                                                            <Icon
                                                                type={dataMedia && dataMedia.status ? 'lock' : 'unlock'}/> {dataMedia.status ? 'Désactiver' : 'Activer'}
                                                        </li>
                                                    </Can>
                                                    {dataMedia.kind === "gallery" && (dataMedia.contentReview === 1 || dataMedia.sfwModerate) ? (
                                                        <Can action={"manage"} subject={dataMedia} modelName="Media">
                                                            <li className="menu-item"
                                                                onClick={() => mutateUpdateMedia({sfw : !dataMedia.sfw, sfwModerate : true})}>
                                                                <Icon
                                                                    type={dataMedia?.sfw ? 'lock' : 'unlock'}/> {dataMedia?.sfw ? "NSFW" : "SFW"}
                                                            </li>
                                                        </Can>
                                                    ) : null}
                                                    {dataMedia.kind === "video" && ['guest', 'public'].includes(dataMedia.right) ? (
                                                        <Can action={"manage"} subject={dataMedia} modelName="Media">
                                                            <a href={`${createLink("tagModerationTreatmentVideo")}/${dataMedia?._id?.toString()}`}>
                                                                <li className="menu-item" >
                                                                    <Icon
                                                                        type={"pencil"}/> Edit timeline
                                                                </li>
                                                            </a>
                                                        </Can>
                                                    ) : null}
                                                    <Can action={"report"} subject={dataMedia} modelName="Media">
                                                        <li className="menu-item">
                                                            <Report _id={dataMedia._id}
                                                                    kind={"medias"}
                                                                    type={"comment"}
                                                                    handleReport={(message) => mutateReportMedia({message})}
                                                                    title={legendToTitle(dataMedia?.legend || "")}/>
                                                        </li>
                                                    </Can>
                                                </ul>
                                            </Dropdown>
                                        ) : null}

                                        <Modal toggle={isToggleAlertDelete}
                                               handleClose={() => setIsToggleAlertDelete(false)}>
                                            <Alert text="Voulez-vous vraiment supprimer ce média ?"
                                                   handleClose={() => setIsToggleAlertDelete(false)}
                                                   handleDelete={() => handleDeletePicture()}/>
                                        </Modal>
                                        <Modal toggle={desactivatePictureAlert}
                                               handleClose={() => setDesactivatePictureAlert(false)}>
                                            <Alert
                                                text={`Voulez-vous vraiment ${dataMedia.status ?  'désactiver' : 'Activer'} ce média ?`}
                                                handleClose={() => setDesactivatePictureAlert(false)}
                                                handleDelete={() => handleStatusMedia()}/>
                                        </Modal>
                                        <Modal toggle={toggleMovePicture}
                                               handleClose={() => setToggleMovePicture(false)}>
                                            <MoveMedia
                                                handleMovePicture={handleMovePicture}
                                                mediaId={dataMedia._id}
                                                handleClose={() => setToggleMovePicture(false)}
                                                userId={_.get(dataMedia,"owner._id")}
                                                activeAlbumId={dataMedia && dataMedia.album && dataMedia.album._id}
                                            />
                                        </Modal>
                                        <Modal toggle={toggleMediaEdit}
                                               handleClose={() => setToggleMediaEdit(false)}>
                                            <MediaEdit
                                                currentMediaId={dataMedia._id}
                                                handleClose={handlePicture}
                                            />
                                        </Modal>
                                        <Modal toggle={toggleWarning}
                                               handleClose={() => setToggleWarning(false)}>
                                            <Warning
                                                username={_.get(dataMedia,"owner.username") || ""}
                                                userId={_.get(dataMedia,"owner._id") || null}
                                                handleClose={() => setToggleWarning(false)}
                                            />
                                        </Modal>
                                    </div>
                                    <div className="mv-action-row">
                                        <LikeBtn parentId={dataMedia._id}
                                            isLiked={dataMedia.isLiked}
                                            likeType={"medias"} />
                                            {isSuccessCurrentUser && (
                                                <div className="mv-action-bookmark" onClick={()=>handleBookmark()}>
                                                    <FontAwesomeIcon icon={isBookmarked ? faBookmarkSolid : faBookmark}/>
                                                </div>
                                            )}
                                        
                                    </div>
                                    <div className="media-infos column">
                                        {!isPage ? <Advertising sizeMobile={"300x100"} className={"center"} /> : null}
                                        <ViewMore limit={heightLimit}>
                                            <Reader text={dataMedia.legend} meta={{
                                                mention : dataMedia.mentions
                                            }}/>
                                        </ViewMore>

                                    </div>
                                    <div className={"suggestions-group"}>
                                        {dataMedia.categories && dataMedia.categories.map(item=>{
                                            if(item.isUri){
                                                return (
                                                    <div key={item._id} ><a href={createLink('facette', {slug : item.uri})}>
                                                        <Button
                                                            size={"small"}
                                                            btnStyle={"primary-reverse"}
                                                            //onClick={() => this.setState({toggle : true})}
                                                            content={item.title}/>
                                                    </a></div>
                                                )
                                            }
                                            else{
                                                return (
                                                    <div className={"no-uri"} key={item._id} ><Button
                                                        size={"small"}
                                                        btnStyle={"primary-reverse"}
                                                        onClick={() => gotoUrl(item.uri)}
                                                        content={item.title}/></div>
                                                )
                                            }

                                        })}
                                    </div>

                                    <div className="group-link">
                                        <ul className="ul-link">
                                            {dataMedia._id &&
                                                <Fragment>
                                                        <span  className={`media-stats likes-text ${dataMedia.count.like >= 1 ? "cursor-pointer" : "" }`} onClick={()=>dataMedia.count.like >= 1 ? setToggleLikeList(true) : null}>
                                                            <Icon type={"heart-full"} />
                                                            {separateurNumber(dataMedia.count.like)}
                                                        </span>
                                                    <Modal toggle={toggleLikeList} handleClose={()=>setToggleLikeList(false)}>
                                                        <LikeList handleClose={()=>setToggleLikeList(false)}
                                                                  value={dataMedia.count.like}
                                                                  likeType={"medias"}
                                                                  parentId={dataMedia._id} />
                                                    </Modal>
                                                </Fragment>
                                            }
                                            <div className={`media-stats`}>
                                                <Icon type="eye"/> {separateurNumber(genererViews(dataMedia?.count?.view || 0)) || 0}
                                            </div>
                                            <ViewsComment type={"icon"} className="media-stats" value={dataMedia?.count?.comment}/>
                                            <div className={`media-stats`}>
                                                <FontAwesomeIcon icon={faBookmarkSolid}/> {separateurNumber(genererViews(dataMedia?.count?.bookmark || 0)) || 0}
                                            </div>
                                            {/*<span className={"media-stats share-link"}>*/}
                                            {/*    Partager*/}
                                            {/*</span>*/}
                                        </ul>
                                    </div>
                                </div>

                                <Comments
                                    onFocus={() => setIsEnableArrow(false)}
                                    onBlur={() => setIsEnableArrow(true) }
                                    type={"medias"}
                                    parent={dataMedia}
                                    commentsAllowed={_.get(dataMedia,"comment.allowed") || false}
                                    className={"column media-comments-container"}
                                />
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    )
};

export const ModalMediaViewer = ({handleClose, mediaId, mediaSlug, toggle})=>(
    <Modal toggle={toggle} handleClose={handleClose}>
        <MediaViewer mediaId={mediaId} mediaSlug={mediaSlug} handleClose={handleClose} />
    </Modal>
);

export default React.memo(MediaViewer);